<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import { BaseIcon, BaseTooltip } from '@cplug/design-system/components'
import {
  BaseIconName,
  BaseIconSize,
  TooltipPosition
} from '@cplug/design-system/components/props'
import type { MenuItem } from '@cplug/frontend-core/composables'
import { useMenuAppContextsTranslation } from '~/domain/shared/navigation/composables/useMenuAppContexts.i18n'

const props = defineProps<{
  item: MenuItem
}>()

const { t } = useMenuAppContextsTranslation()

const isComingSoon = computed(() => props.item.name === 'loja' || props.item.name === 'pagamentos')

const iconName = computed(() => {
  const icon = props.item.icon
  return typeof icon === 'string' ? icon as BaseIconName : icon ?? BaseIconName.Desktop
})

const tooltipMessage = computed(() => {
  if (props.item.name === 'loja') {
    return t('SoonTooltipStore')
  }
  if (props.item.name === 'pagamentos') {
    return t('SoonTooltipPayments')
  }
  return ''
})

const rootRef = ref<HTMLElement | null>(null)

function syncParentAnchorTooltip (): void {
  if (!isComingSoon.value) {
    return
  }

  const anchor = rootRef.value?.closest('a')
  if (!anchor) {
    return
  }

  anchor.removeAttribute('title')
  anchor.setAttribute('aria-label', tooltipMessage.value)
}

onMounted(syncParentAnchorTooltip)
watch(tooltipMessage, syncParentAnchorTooltip)
</script>

<template>
  <BaseTooltip
    :message="tooltipMessage"
    :position="TooltipPosition.Right"
  >
    <span
      ref="rootRef"
      class="relative inline-flex h-9 w-9 items-center justify-center"
    >
      <BaseIcon
        v-if="iconName"
        :name="iconName"
        :size="BaseIconSize.Small"
      />
      <span
        v-if="isComingSoon"
        class="bg-warning-strong text-primary-foreground ring-sidebar absolute -top-1 -right-1 z-10 rounded-full px-1 py-px text-[8px] leading-none font-bold whitespace-nowrap ring-2"
      >
        {{ t('SoonBadge') }}
      </span>
    </span>
  </BaseTooltip>
</template>
